import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'

const Index = () => {
  const [androidVersion, setAndroidVersion] = useState({
    versionCode: '',
    versionName: ''
  });
  const [iosVersion, setIosVersion] = useState({
    versionCode: '',
    versionName: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchVersions();
  }, []);

  const fetchVersions = async () => {
    try {
      setLoading(true);
      // Fetch Android version
      const androidResponse = await fetch("https://api.experts4u.in/api/v2/AppVersion2/get?type=android");
      const androidData = await androidResponse.json();
      if (androidData.success) {
        setAndroidVersion({
          versionCode: androidData.data.versionCode,
          versionName: androidData.data.version
        });
      }

      // Fetch iOS version
      const iosResponse = await fetch("https://api.experts4u.in/api/v2/AppVersion2/get?type=ios");
      const iosData = await iosResponse.json();
      if (iosData.success) {
        setIosVersion({
          versionCode: iosData.data.versionCode,
          versionName: iosData.data.version
        });
      }
    } catch (error) {
      console.error('Error fetching versions:', error);
      toast.error('Failed to fetch version data');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      
      const headers = new Headers();
      headers.append("Content-Type", "application/json");

      // Save Android version
      const androidRaw = JSON.stringify({
        type: "android",
        version: androidVersion.versionName,
        versionCode: androidVersion.versionCode
      });

      const androidResponse = await fetch("https://api.experts4u.in/api/v2/AppVersion2/add-update", {
        method: 'POST',
        headers: headers,
        body: androidRaw,
        redirect: 'follow'
      });
      const androidResult = await androidResponse.json();

      // Save iOS version
      const iosRaw = JSON.stringify({
        type: "ios",
        version: iosVersion.versionName,
        versionCode: iosVersion.versionCode
      });

      const iosResponse = await fetch("https://api.experts4u.in/api/v2/AppVersion2/add-update", {
        method: 'POST',
        headers: headers,
        body: iosRaw,
        redirect: 'follow'
      });
      const iosResult = await iosResponse.json();

      if (androidResult.success && iosResult.success) {
        toast.success('Versions updated successfully');
      } else {
        toast.error('Failed to update versions');
      }
    } catch (error) {
      console.error('Error saving versions:', error);
      toast.error('Failed to save version data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-5 mt-4">
      <div className="row justify-content-center">
        <div className="col-md-11">
          <div className="card shadow">
            <div className="card-header bg-gradient d-flex align-items-center justify-content-between">
              <h4 className="card-title mb-0">App Version</h4>
            </div>
            <div className="card-body">
              {loading ? (
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <>
                  {/* Android Version */}
                  <div className="mb-4">
                    <h5 className="mb-3">Android Version</h5>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Version Code</label>
                        <input
                          type="number"
                          className="form-control"
                          value={androidVersion.versionCode}
                          onChange={(e) => setAndroidVersion({...androidVersion, versionCode: e.target.value})}
                          placeholder="Enter Android version code"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Version Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={androidVersion.versionName}
                          onChange={(e) => setAndroidVersion({...androidVersion, versionName: e.target.value})}
                          placeholder="Enter Android version name (e.g., 1.0.0)"
                        />
                      </div>
                    </div>
                  </div>

                  {/* iOS Version */}
                  <div className="mb-4">
                    <h5 className="mb-3">iOS Version</h5>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Version Code</label>
                        <input
                          type="number"
                          className="form-control"
                          value={iosVersion.versionCode}
                          onChange={(e) => setIosVersion({...iosVersion, versionCode: e.target.value})}
                          placeholder="Enter iOS version code"
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Version Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={iosVersion.versionName}
                          onChange={(e) => setIosVersion({...iosVersion, versionName: e.target.value})}
                          placeholder="Enter iOS version name (e.g., 1.0.0)"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Save Button */}
                  <div className="text-end">
                    <button 
                      className="btn btn-primary px-4"
                      onClick={handleSave}
                      disabled={loading}
                    >
                      {loading ? 'Saving...' : 'Save Changes'}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Index